import boards from "data/boards.json";
import sections from "data/sections.json";
import { Board } from "./data/types";

export type BoardSection = {
  _id: string;
  order: number;
  title: string;
  boards: string[];
};

const boardCatalog = boards as Board[];
const boardSections = sections as BoardSection[];
const boardSlugs = boardCatalog.map(({ slug }) => slug);

export function getBoards() {
  return boardCatalog;
}

export function getSections() {
  return boardSections;
}

export function getBoardSlugs() {
  return boardSlugs;
}

export function getBoardBySlug(boardSlug?: string | null) {
  if (!boardSlug) {
    return undefined;
  }

  return boardCatalog.find((board) => board.slug === boardSlug);
}
